<p-toast></p-toast>
<p-card styleClass="p-card-shadow">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="Export" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="inventoryData"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'VendorName',
		'ProgrammeName',
		'component',
		'size',
		'Quantity',
		'PreviouslyConsumedQuantity',
		'RemaningQuantity',
		'BatchNO',
        'LotNo',
        'PurchaseInvoiceNo',
        'ItemType'
        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true" [loading]="loading">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'INVENTORY_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="VendorName">{{'VENDOR_NAME'| translate}}
                    <p-columnFilter type="text" field="VendorName" display="menu"></p-columnFilter>
                    <p-sortIcon field="VendorName"></p-sortIcon>
                </th>
                <th pSortableColumn="ProgrammeName">{{'PROGRAMME_NAME'| translate}}
                    <p-columnFilter type="text" field="ProgrammeName" display="menu"></p-columnFilter>
                    <p-sortIcon field="ProgrammeName"></p-sortIcon>
                </th>
                <th pSortableColumn="component">{{'COMPONENT'| translate}}
                    <p-columnFilter type="text" field="component" display="menu"></p-columnFilter>
                    <p-sortIcon field="component"></p-sortIcon>
                </th>
                <th pSortableColumn="size">{{'SIZE'| translate}}
                    <p-columnFilter type="text" field="size" display="menu"></p-columnFilter>
                    <p-sortIcon field="size"></p-sortIcon>
                </th>
                <th pSortableColumn="Quantity">{{'QUANTITY'| translate}}
                    <p-columnFilter type="text" field="Quantity" display="menu"></p-columnFilter>
                    <p-sortIcon field="Quantity"></p-sortIcon>
                </th>
                <th pSortableColumn="PreviouslyConsumedQuantity">{{'PREVIOUSLY_CONSUMED_QUANTITY'| translate}}
                    <p-columnFilter type="text" field="PreviouslyConsumedQuantity" display="menu"></p-columnFilter>
                    <p-sortIcon field="PreviouslyConsumedQuantity"></p-sortIcon>
                </th>
                <th pSortableColumn="RemaningQuantity">{{'REMAINING_QUANTITY'| translate}}
                    <p-columnFilter type="text" field="RemaningQuantity" display="menu"></p-columnFilter>
                    <p-sortIcon field="RemaningQuantity"></p-sortIcon>
                </th>
                <th pSortableColumn="BatchNO">{{'BATCH_NO'| translate}}
                    <p-columnFilter type="text" field="BatchNO" display="menu"></p-columnFilter>
                    <p-sortIcon field="BatchNO"></p-sortIcon>
                </th>
                <th pSortableColumn="LotNo">{{'LOT_NO'| translate}}
                    <p-columnFilter type="text" field="LotNo" display="menu"></p-columnFilter>
                    <p-sortIcon field="LotNo"></p-sortIcon>
                </th>
                <th pSortableColumn="PurchaseInvoiceNo">{{'PURCHASE_INVOICE_NO'| translate}}
                    <p-columnFilter type="text" field="PurchaseInvoiceNo" display="menu"></p-columnFilter>
                    <p-sortIcon field="PurchaseInvoiceNo"></p-sortIcon>
                </th>
                <th pSortableColumn="ItemType">{{'ITEM_TYPE'| translate}}
                    <p-columnFilter type="text" field="ItemType" display="menu"></p-columnFilter>
                    <p-sortIcon field="ItemType"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-inventoryData>
            <tr>
                <td>{{inventoryData.VendorName}}</td>
                <td>{{inventoryData.ProgrammeName}}</td>
                <td>{{inventoryData.component}}</td>
                <td>{{inventoryData.size}}</td>
                <td>{{inventoryData.Quantity}}</td>
                <td>{{inventoryData.PreviouslyConsumedQuantity}}</td>
                <td>{{inventoryData.RemaningQuantity}}</td>
                <td>{{inventoryData.BatchNO}}</td>
                <td>{{inventoryData.LotNo}}</td>
                <td>{{inventoryData.PurchaseInvoiceNo}}</td>
                <td>{{inventoryData.ItemType}}</td>
                
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>
